import { AutogenModelExciseTaxRate, AutogenRowExciseTaxRate } from "./autogen/AutogenModelExciseTaxRate";

export class ModelExciseTaxRate extends AutogenModelExciseTaxRate<RowExciseTaxRate> {
	constructor() {
		super(RowExciseTaxRate);
	}
}

export class RowExciseTaxRate extends AutogenRowExciseTaxRate {
}